module.exports = __webpack_public_path__ + "img/noData.19797dc5.png";